const KEY = "hbc_recently_viewed";

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const addRecent = (p) => {
  if (!p || !p.id) return;
  const slim = {
    id: p.id, slug: p.slug, name: p.name, price: p.price, sale_price: p.sale_price,
    images: (p.images || []).slice(0, 2), sizes: p.sizes, colours: p.colours,
    is_new: p.is_new, best_seller: p.best_seller, category: p.category, currency: p.currency,
    stock: p.stock,
  };
  const list = getRecent().filter((x) => x.id !== p.id);
  list.unshift(slim);
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (err) { console.warn("Recently viewed not saved (storage unavailable)", err); }
};
